module.exports = __webpack_public_path__ + "img/icon_aside_ppt3_active.b12964a5.svg";